export const COUNTRY_CODE_COORDINATE_MAPPING = {
    us: [-118.16375217333335, 33.81326342],
    th: [100.523186, 13.736717],
};
export const COUNTRY_CODE_DEFAULT_ZOOM_MAPPING = {
    us: 11,
    th: 13,
};
